/**
 * Critical control points (YC-21): an execution step carries `isCcp: true` when
 * something in it is critical. The flag is all there is — no limit, no
 * corrective action. A step without the key is not flagged, so every step saved
 * before the flag existed is "off". Pure, so the views only draw it.
 */

/** True only for `isCcp === true`; absent, false or anything else is not flagged. */
export function isCcpStep(step: unknown): boolean {
  return !!step && typeof step === "object" && (step as { isCcp?: unknown }).isCcp === true;
}

/** How many steps of a recipe's `instructions` are flagged. */
export function ccpStepCount(instructions: unknown): number {
  return Array.isArray(instructions) ? instructions.filter(isCcpStep).length : 0;
}

/** True when any step shown in the method is flagged, so the legend is worth drawing. */
export function methodHasCcp(method: { groups: { steps: { isCcp?: boolean }[] }[] }): boolean {
  return method.groups.some((group) => group.steps.some((step) => step.isCcp === true));
}

/**
 * The number an acknowledgement names a step by: its own `step`, else its
 * 1-based place in the list — the same rule the API and the stages use.
 */
export function ccpStepNumber(step: { step?: number }, index: number): number {
  return typeof step.step === "number" && step.step > 0 ? step.step : index + 1;
}
